import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const SLUGS = [
  { key: "privacy", label: "Privacy Policy" },
  { key: "terms", label: "Terms of Service" },
];

export function ModPages() {
  const [slug, setSlug] = useState("privacy");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = (s) => {
    setLoading(true);
    api.get(`/pages/${s}`).then((r) => { setTitle(r.data.title); setContent(r.data.content); }).finally(() => setLoading(false));
  };
  useEffect(() => load(slug), [slug]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/pages/${slug}`, { title, content });
      toast.success("Saved");
    } catch {
      toast.error("Error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-4 flex gap-1 rounded-md border border-zinc-800 bg-zinc-900/60 p-0.5">
        {SLUGS.map((s) => (
          <button
            key={s.key}
            data-testid={`page-tab-${s.key}`}
            onClick={() => setSlug(s.key)}
            className={`rounded px-3 py-1.5 text-[13px] font-medium ${slug === s.key ? "bg-zinc-800 text-zinc-100" : "text-zinc-400 hover:text-zinc-200"}`}
          >
            {s.label}
          </button>
        ))}
      </div>
      {loading ? (
        <div className="grid h-40 place-items-center"><Loader2 className="animate-spin text-zinc-600" /></div>
      ) : (
        <div className="rounded-lg border border-zinc-800/70 bg-[#111113] p-5">
          <label className="mb-1.5 block text-[12px] text-zinc-300">Title</label>
          <Input data-testid="page-title" value={title} onChange={(e) => setTitle(e.target.value)} className="mb-4 border-zinc-800 bg-zinc-950 text-[14px]" />
          <label className="mb-1.5 block text-[12px] text-zinc-300">Content</label>
          <Textarea data-testid="page-content" value={content} onChange={(e) => setContent(e.target.value)} className="min-h-[340px] border-zinc-800 bg-zinc-950 font-mono text-[13px] leading-relaxed" />
          <Button data-testid="page-save" onClick={save} disabled={saving} className="mt-4 bg-blue-600 text-white hover:bg-blue-700">
            {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Save
          </Button>
        </div>
      )}
    </div>
  );
}
